import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class Observations extends Component {
  render() {
    const { title, name } = this.props;
    return (
      <div className={"col-md-6"}>
        <div className="card full-height">
          <div className="card-header">
            <div className="card-title">{title}</div>
          </div>
          <div className="card-body">
            <div className="d-flex">
              <div className="flex-1 ml-3 pt-1">
                <Field
                  name={name}
                  className="form-control"
                  component="textarea"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default compose(
  withRouter,
  connect(),
  reduxForm({
    form: "Observations"
  })
)(Observations);
